export default function Store(opts = {}) {
    const options = resolveOptions(opts);
    const store = {...options.items};

    function resolveOptions(opts = {}) {
        return {
            validator: () => true,
            valueTransformer: value => value,
            keyTransformer: key => key,
            items: {},
            ...opts
        }
    }

    function validate(value) {
        if (! options.validator(value)) {
            console.log(value);
            throw new Error('[Store]: Value validator returned falsy result for value (logged above).');
        }
    }

    function has(key) {
        return store.hasOwnProperty(
            options.keyTransformer(key)
        );
    }

    function get(key) {
        return options.valueTransformer(
            store[options.keyTransformer(key)]
        );
    }

    function remove(key) {
        delete store[
            options.keyTransformer(key)
        ];
    }

    function set(key, value) {
        validate(value);

        store[options.keyTransformer(key)] = value;
    }

    function empty() {
        for (const key in store) {
            remove(key);
        }
    }

    return {
        has,
        get,
        set,
        remove,
        empty
    }
}